import { render, staticRenderFns } from "./CommercialBrandTable.vue?vue&type=template&id=ac2c7a9e"
import script from "./CommercialBrandTable.vue?vue&type=script&lang=js"
export * from "./CommercialBrandTable.vue?vue&type=script&lang=js"
import style0 from "./CommercialBrandTable.vue?vue&type=style&index=0&id=ac2c7a9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports